import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import media from "styled-media-query";
import breakpoints from "Framework/helpers/BreakpointHelper/BreakpointHelper";
import { PrimaryButton } from "./";
import { Icon, PhoneVolume } from "BaseComponents/Icons/Svg";

export const IconButton = ({ label, icon, color, innerClassName, ...rest }) => {
  return (
    <StyledIconButton className={innerClassName} {...rest} {...{ color }}>
      {icon !== "icon-phone-2" && (
        <Icon
          margin="0"
          {...{ color }}
          fontSize="20px"
          className={`${icon} iconBtn`}
        ></Icon>
      )}
      {icon === "icon-phone-2" && (
        <PhoneVolume margin="0" {...{ color }}></PhoneVolume>
      )}
      <span>{label}</span>
    </StyledIconButton>
  );
};

IconButton.propTypes = {};

export const StyledIconButton = styled(PrimaryButton)`
  & {
    margin: 15px 0 0 0;
  }
  padding: ${({ padding }) => (padding ? padding : "0 20px")};
  margin-left: 0;
  text-align: center;
  border-radius: 20px;
  ${({ minWidth }) =>
    minWidth &&
    css`
      min-width: ${({ minWidth }) => minWidth};
    `}

  span {
    color: ${({ theme }) => theme.colors.footerSpanColor};
    font-size: 18px;
    padding: 0 0.5rem;
    line-height: 1.5em;
    display: inline-block;
    opacity: 1;
    font-family: ${({ theme }) => theme.font};
    transition: all 0.2s ease;
  }
  ${media.lessThan(breakpoints.mobile)`
	&{
		margin: 10px 0 0 0;
	}
	`}
  &:hover,
	&:focus {
    background-color: white;
    i:before {
      color: black;
      transition: 0.2s ease;
    }

    svg {
      color: black;
    }

    span {
      color: black;
    }
  }
`;
